/* eslint-disable prettier/prettier */
import { get as getAxios } from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });

export default class Dashboard {
  static async getHappinessReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    // 🔹 Fetch from API (awaited)
    const response = await get(
      `/api/reporting/happiness-counters?memberId=${accessMemberIdFromLocal}`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    return response;
  }

  static getSubscriptionReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/subscription-counter`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Dashboard.getSubscriptionReport.cancel = request.cancel;
    return request;
  }

  static getSubscriptionReportVC(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT

    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0; // correct ID according to role

    const request = get(
      `/api/reporting/subscription-counter-vc?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Dashboard.getSubscriptionReport.cancel = request.cancel;
    return request;
  }

  static getGlipmseReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/structure/glimpse`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Dashboard.getGlipmseReport.cancel = request.cancel;
    return request;
  }

  static getFriendToMembers(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/friends/conversion-count`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static async getFriendToMemberTrends(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    // 🔹 Fetch from API (await!)
    const response = await get(
      `/api/reporting/friends/friend-to-member-trends?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}&friendToMember=true&newFriend=true`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    // 🔹 Return actual data
    return response.data;
  }

  // static getFriendMonthlyTrend(data) {
  //   const accessTokenFromLocal = localStorage.getItem("authToken");
  //   const accessMemberIdFromLocal = localStorage.getItem("memberId");
  //   const accessAreaIdFromLocal = localStorage.getItem("areaId");
  //   const accessPositionRoleFromLocal = localStorage.getItem("positionRole");
  //   const currentYear = new Date().getFullYear();

  //   const request = get(
  //     `/api/reporting/friends/friend-monthly-trend?memberId=${accessMemberIdFromLocal}&year=${currentYear}&hierarchy=${accessPositionRoleFromLocal}&position=${accessAreaIdFromLocal}&friendToMember=true&newFriend=true`,
  //     {
  //       accessToken: accessTokenFromLocal, // ensure this is correct
  //       data,
  //     }
  //   );

  //   Dashboard.getFriendToMembers.cancel = request.cancel;
  //   return request;
  // }
  static getFriendMonthlyTrend(data) {
    const accessToken = localStorage.getItem("authToken");
    const memberId = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT

    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0; // correct ID according to role

    const currentYear = new Date().getFullYear();

    const request = get(
      `/api/reporting/friends/friend-monthly-trend?memberId=${memberId}&year=${currentYear}&hierarchy=${positionRole}&position=${positionValue}&friendToMember=true&newFriend=true`,
      {
        accessToken,
        data,
      }
    );

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static getOrganizationStatistics(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/organization-statistics?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static getExamReportData() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/examination/applied/get-exam-report`, {
      accessToken: accessTokenFromLocal,
    });

    Dashboard.getExamReportData.cancel = request.cancel;
    return request;
  }

  static getIntermediateCount() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reports/examination/applied/intermediate-count`, {
      accessToken: accessTokenFromLocal,
    });

    Dashboard.getIntermediateCount.cancel = request.cancel;
    return request;
  }

  static getLeadershipStatistics(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/leadership-statistics?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static getMembershipStatistics(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/membership-statistics?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static getMembershipByDivision(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/membership-by-division-statistics?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static gohonzonMembersCount(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/gohonzon-members-count?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.getFriendToMembers.cancel = request.cancel;
    return request;
  }

  static async notificationRequest(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessAreaFromLocal = localStorage.getItem("areaId");

    try {
      // 🔹 Parallel API calls
      const [introductionRes, friendRes, membersRes] = await Promise.all([
        get(
          `/api/introductions?initiatorAreaId=${accessAreaFromLocal}&pageNumber=0&pageSize=100`,
          { accessToken: accessTokenFromLocal, data }
        ),
        get(
          `/api/friends/pendingTransfers?initiatorAreaId=${accessAreaFromLocal}&page=0&size=100`,
          { accessToken: accessTokenFromLocal, data }
        ),
        get(
          `/api/members/pendingTransfers?initiatorAreaId=${accessAreaFromLocal}&page=0&size=100`,
          { accessToken: accessTokenFromLocal, data }
        ), // ✅ FIX: added leading slash before api/
      ]);

      // 🔹 Extract counts safely (based on Postman data structure)
      const introductionCount =
        introductionRes?.data?.totalElements ??
        introductionRes?.totalElements ??
        0;

      const friendCount =
        friendRes?.data?.totalElements ?? friendRes?.totalElements ?? 0;

      const membersCount =
        membersRes?.data?.totalElements ?? membersRes?.totalElements ?? 0;

      // console.log(
      //   "notificationss dash",
      //   introductionCount,
      //   friendCount,
      //   membersCount
      // );

      // 🔹 Only include non-zero messages
      const messages = [];

      if (introductionCount > 0) {
        messages.push({
          id: 1,
          type: "introduction",
          text: `${introductionCount} Introduction(s) request pending`,
          // path: "/introduction/view",
        });
      }

      if (friendCount > 0) {
        messages.push({
          id: 2,
          type: "friend",
          text: `${friendCount} Friend(s) transfer request pending`,
          // path: "/friends/transfer",
        });
      }

      if (membersCount > 0) {
        messages.push({
          id: 3, // ✅ FIX: make unique ID
          type: "members",
          text: `${membersCount} Member(s) transfer request pending`,
          // path: "/members/transfer",
        });
      }

      return {
        messages,
        total: introductionCount + friendCount + membersCount,
      };
    } catch (error) {
      console.error("Error fetching notifications:", error);
      return {
        messages: [],
        total: 0,
      };
    }
  }

  static dashboardSetting() {
    const accessTokenFromLocal = localStorage.getItem("authToken");

    const request = get(`/api/settings`, { accessToken: accessTokenFromLocal });
    Dashboard.dashboardSetting.cancel = request.cancel;
    return request;
  }

  static BsgVisionData(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/bsg-vision-data?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.BsgVisionData.cancel = request.cancel;
    return request;
  }

  static BsgVisionDataForUnit(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const accessMemberIdFromLocal = localStorage.getItem("memberId");
    const positionRole = localStorage.getItem("positionRole"); // AREA / ZONE / REGION / CHAPTER / DISTRICT
    // all ids from localStorage
    const areaId = localStorage.getItem("areaId");
    const zoneId = localStorage.getItem("zoneId");
    const regionId = localStorage.getItem("regionId");
    const chapterId = localStorage.getItem("chapterId");
    const districtId = localStorage.getItem("districtId");

    // 🔥 AUTO MAP based on hierarchy
    const positionMap = {
      Area: areaId,
      Zone: zoneId,
      Region: regionId,
      Chapter: chapterId,
      District: districtId,
    };

    const positionValue = positionMap[positionRole] ?? 0;

    const request = get(
      `/api/reporting/structure/bsg-vision-data-for-unit?memberId=${accessMemberIdFromLocal}&hierarchy=${positionRole}&position=${positionValue}`,
      {
        accessToken: accessTokenFromLocal, // ensure this is correct
        data,
      }
    );

    Dashboard.BsgVisionDataForUnit.cancel = request.cancel;
    return request;
  }
}
